import { Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute,NavigationEnd,Router,Event as NavigationEvent } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CatalogueFilterService } from '../../../shared/services/catalogue-filter.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-catalogue-filter',
  standalone: true,
  imports: [CommonModule,FormsModule,ReactiveFormsModule,MatAutocompleteModule],
  templateUrl: './catalogue-filter.component.html',
  styleUrl: './catalogue-filter.component.scss'
})
export class CatalogueFilterComponent implements OnInit, OnDestroy {
  catalogueList: any[] = [];
  filteredCatalogueList: any[] = [];
  languageList:any = [];
  categoryList:any = [];
  sub: Subscription = new Subscription();
  languageId:any = '';
  categoryId:any = '';
  pageSize = 10;
  pageNumber = 1;
  totalCount: any;
  myControl = new FormControl();
  event$: any;
  showSearchBar: boolean = true;
  searchedcatalogue: any[] = [];
  environment: any;
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;
  showContactInfo: boolean = true;

  constructor(private catalogueService: CatalogueFilterService, public utils: UtilsService, private metaSvc: MetaMgmtService, private route: ActivatedRoute, private jsonDataService: JsonDataService, private router: Router, @Inject(PLATFORM_ID) private platformId: any) {
    this.utils.showHeaderFooter.next(true);
      this.environment = environment; // Make sure to import environment from your environment files

    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);
    },
    error: (err: any) => {
      this.utils.hideLoading()
      console.error('Error fetching meta data', err);
    }}));
    this.sub.add(this.event$ = this.router.events
      .subscribe(
        (event: NavigationEvent) => {
          if (event instanceof NavigationEnd) {
            this.myControl.setValue('');
          }
        }));
  }

  ngOnInit(): void {
    this.getCatalogueList('new');
    this.getLanguageList();
    this.getCategoryList();

    // Subscribe to search input changes for filtering
    this.sub.add(
      this.myControl.valueChanges.pipe(
        debounceTime(300),  // Wait for 300ms pause in events
        distinctUntilChanged() // Only emit when the current value is different from the last
      ).subscribe(value => {
        this.filterCatalogues(value);
      })
    );
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(event: any) {
    if (document.documentElement.scrollTop >= 49 && this.showSearchBar) {
      this.showSearchBar = false;
      if (this.autocomplete)
        this.autocomplete.closePanel();
    }
    else if (document.documentElement.scrollTop < 49 && !this.showSearchBar) {
      this.showSearchBar = true;
    }
    if (document.documentElement.scrollTop > 100 && this.showContactInfo) {
      this.showContactInfo = false;
    } else if (document.documentElement.scrollTop <= 100 && !this.showContactInfo) {
      this.showContactInfo = true;
    }
  }

  getCatalogueList(type: string, isFromSearch: boolean = false) {
    if (type === 'new') {
        this.catalogueList = [];
        this.filteredCatalogueList = [];
        this.pageNumber = 1;
    }

    if(!isFromSearch){
      this.myControl.setValue('')
    }
    this.utils.showLoading();

    let body = {
        "categoryGuidId": this.categoryId !== '' ? this.categoryId : undefined,
        "languageGuidId": this.languageId !== '' ? this.languageId : undefined,
        "pageSize": isFromSearch ? this.totalCount : 10,
        "pageNumber": isFromSearch ? 1 : this.pageNumber++,
    };

    this.sub.add(this.catalogueService.getCatalogueList(body).subscribe((data) => {
        this.utils.hideLoading();

        if (data.success) {
            if (data.catalogueList.length) {
                this.catalogueList = isFromSearch ? [...data.catalogueList] : [...this.catalogueList, ...data.catalogueList];

                if (isFromSearch) {
                    this.filteredCatalogueList = [...data.catalogueList]; // Clear and append new data
                } else {
                    this.filteredCatalogueList = [...this.catalogueList]; // Keep existing working
                }

                this.totalCount = data.totalCategoryCount;
            }
        } else {
            this.pageNumber--; // Prevent unnecessary pagination increase
            this.utils.openSnackBar(data.message ? data.message : 'Something went wrong!!', 'error-toster');
        }
    }));
}



  // New method to filter catalogues based on search term
  filterCatalogues(searchTerm?: string) {
    if (!searchTerm) {
      // If search is cleared, show all catalogues
      this.filteredCatalogueList = [...this.catalogueList];
      return;
    }
  
    searchTerm = searchTerm.toLowerCase().trim();
    this.filteredCatalogueList = this.catalogueList.filter(catalogue => {
      return (
        catalogue.catalogueName?.toLowerCase().includes(searchTerm) ||
        catalogue.languageName?.toLowerCase().includes(searchTerm)
      );
    });
  }
  getRecentlySearched(searchKeyword: string) {
    searchKeyword = searchKeyword?.trim() || '';

    if (!searchKeyword) {
        return;
    }

    // Check if the keyword is already present in `filteredCatalogueList`
    const isKeywordExists = this.filteredCatalogueList.some(catalogue =>
        catalogue.catalogueName?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        catalogue.languageName?.toLowerCase().includes(searchKeyword.toLowerCase())
    );

    if (isKeywordExists) {
        return;
    }

    this.utils.showLoading();
    this.getCatalogueList(searchKeyword, true); // Pass `true` for isFromSearch
}

  // Method to handle Enter key press
  onEnter(event: any) {
    if (event.key === 'Enter') {
        event.preventDefault(); // Prevent default only for Enter key
        this.getRecentlySearched(this.myControl.value);
    } else {
        // Handle other key presses if needed
        this.getRecentlySearched(this.myControl.value);
    }
}

  // Method to handle clicking on a search suggestion
  onSearchClick() {
    setTimeout(() => {
      this.getRecentlySearched(this.myControl.value);
    }, 0);
  }

  
  // Method to clear search
  clearSearch() {
    this.myControl.setValue('');
    this.filteredCatalogueList = [...this.catalogueList];
  }

  getLanguageList() {
    this.myControl.setValue('');
    this.utils.showLoading();
    this.sub.add(this.catalogueService.getLanguageList().subscribe((res) => {
      this.utils.hideLoading();
      if (res.success) {
        this.languageList = res.languages;
      }
      else {
        this.utils.openSnackBar(res.message ? res.message : 'something went wrong!!', 'error-toster');
      }
    }))
  }

  getCategoryList() {
    this.myControl.setValue('');
    this.utils.showLoading();
    let body = {
      "searchArgs": "",
      "sortBy": "",
      "sortDirection": "",
      "pageSize": 1000,
      "pageNumber": 1
    }
    this.sub.add(this.catalogueService.getCategoryList(body).subscribe((res) => {
      this.utils.hideLoading();
      if (res.success) {
        this.categoryList = res.categoryList;
      }
      else {
        this.utils.openSnackBar(res.message ? res.message : 'something went wrong!!', 'error-toster');
      }
    }))
  }

  downloadCatalogue(url: string) {
    if(isPlatformBrowser(this.platformId)) {  
      window.open(url, '_blank');
    }
  }

  resetFilter() {
    this.languageId = '';
    this.categoryId = '';
    this.myControl.setValue('');
    this.pageSize = 10;
    this.pageNumber = 1;
    this.getCatalogueList('new');
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}